import { Button, Card, Typography } from "antd";

const { Text, Title } = Typography;

export default function LineCutCard({
  target,
  busy,
  onSale,
  onNoSale,
  onRegisterLater,
  onCancel,
}) {
  if (!target) return null;

  const initial = (target.seller_name || "?").trim().charAt(0).toUpperCase();

  return (
    <Card>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "baseline",
        }}>
        <Text type="warning" style={{ letterSpacing: 1 }}>
          FURANDO FILA
        </Text>
        <Button type="text" size="small" disabled={busy} onClick={onCancel}>
          Cancelar
        </Button>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 20,
          margin: "16px 0 24px",
        }}>
        <div
          style={{
            width: 72,
            height: 72,
            borderRadius: "50%",
            background: "var(--ouran-card-header-bg)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 32,
            fontWeight: 600,
            flexShrink: 0,
          }}>
          {initial}
        </div>
        <div>
          <Title level={2} style={{ margin: 0, lineHeight: 1.1 }}>
            {target.seller_name}
          </Title>
          <Text type="secondary">atendendo fora da vez</Text>
        </div>
      </div>

      <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
        <Button
          type="primary"
          size="large"
          loading={busy}
          style={{ height: 56, minWidth: 160, fontSize: 18 }}
          onClick={onSale}>
          Vendeu
        </Button>
        <Button
          danger
          size="large"
          disabled={busy}
          style={{ height: 56, minWidth: 160, fontSize: 18 }}
          onClick={onNoSale}>
          Não vendeu
        </Button>
        <Button
          size="large"
          disabled={busy}
          style={{ height: 56, minWidth: 140 }}
          onClick={onRegisterLater}>
          Registrar Depois
        </Button>
      </div>
    </Card>
  );
}
